<p-skeleton [width]="width" [height]="height" [size]="size" [shape]="shape" [borderRadius]="borderRadius" [styleClass]="className"></p-skeleton>
